// Configuration utility to access environment variables
class Config {
  constructor() {
    this.gaTrackingId = import.meta.env.VITE_GA_MEASUREMENT_ID || '';
    this.recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';
    this.contactFormApi = import.meta.env.VITE_API_CONTACT_FORM || '';
    this.quoteFormApi = import.meta.env.VITE_API_QUOTE_FORM || '';
    this.searchFormApi = import.meta.env.VITE_API_SEARCH_FORM || '';
    this.samlEntityId = import.meta.env.VITE_SAML_ENTITY_ID || '';
    this.samlAcsUrl = import.meta.env.VITE_SAML_ACS_URL || '';
    this.samlSignonUrl = import.meta.env.VITE_SAML_SIGNON_URL || '';
    this.samlNameId = import.meta.env.VITE_SAML_NAME_ID || '';
    this.samlGroupClaims = import.meta.env.VITE_SAML_GROUP_CLAIMS || '';
    this.pricing = {
      managed_help_desk:  { essential: import.meta.env.VITE_PRICE_HELP_DESK_ESSENTIAL    || '$50',    professional: import.meta.env.VITE_PRICE_HELP_DESK_PROFESSIONAL    || '$95'    },
      managed_desktops:   { essential: import.meta.env.VITE_PRICE_DESKTOPS_ESSENTIAL     || '$50',    professional: import.meta.env.VITE_PRICE_DESKTOPS_PROFESSIONAL     || '$175'   },
      managed_security:   { essential: import.meta.env.VITE_PRICE_SECURITY_ESSENTIAL     || '$50',    professional: import.meta.env.VITE_PRICE_SECURITY_PROFESSIONAL     || '$130'   },
      network_operations: { essential: import.meta.env.VITE_PRICE_NOC_ESSENTIAL          || '$2,000', professional: import.meta.env.VITE_PRICE_NOC_PROFESSIONAL          || '$4,500' }
    };
  }

  // Google Analytics configuration
  getGAConfig() {
    return {
      trackingId: this.gaTrackingId,
      enabled: !!this.gaTrackingId && this.gaTrackingId !== 'G-DEV1234567' // Don't track in dev mode with test ID
    };
  }

  // Contact Form API configuration
  getContactFormConfig() {
    return {
      apiUrl: this.contactFormApi
    };
  }

  // Search Form API configuration
  getSearchFormConfig() {
    return {
      apiUrl: this.searchFormApi
    };
  }

  // SAML configuration
  getSAMLConfig() {
    return {
      entityId: this.samlEntityId,
      acsUrl: this.samlAcsUrl,
      signonUrl: this.samlSignonUrl,
      nameId: this.samlNameId,
      groupClaims: this.samlGroupClaims
    };
  }

  // Get current environment based on tracking ID
  getCurrentEnvironment() {
    if (this.gaTrackingId.includes('DEV')) return 'development';
    if (this.gaTrackingId.includes('STAGE')) return 'staging';
    if (this.gaTrackingId.includes('PROD')) return 'production';
    return 'unknown';
  }
}

// Export singleton instance
const config = new Config();
export default config;